import { css } from '@bts-web/utils-style-engine';
import { SkeletonElement } from '../../../common';

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'small',
  width: '100%',
});

const subItemsStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'extra_small_2',
});

const rowStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 'small',
});

const subItemWidths = [
  { label: '56px', value: '64px' },
  { label: '40px', value: '48px' },
];

interface FeesForAmountSkeletonProps {
  lineItemCount?: number;
}

export const FeesForAmountSkeleton = ({
  lineItemCount = 1,
}: FeesForAmountSkeletonProps) => (
  <div data-testid="fees-for-amount-skeleton" className={containerStyles}>
    {lineItemCount > 0 && (
      <div className={subItemsStyles}>
        {Array.from({ length: lineItemCount }, (_, i) => (
          <div key={i} className={rowStyles}>
            <SkeletonElement
              width={subItemWidths[i]?.label ?? '48px'}
              height="12px"
              borderRadius="4px"
            />
            <SkeletonElement
              width={subItemWidths[i]?.value ?? '56px'}
              height="12px"
              borderRadius="4px"
            />
          </div>
        ))}
      </div>
    )}

    <div className={rowStyles}>
      <SkeletonElement width="48px" height="18px" borderRadius="4px" />
      <SkeletonElement width="72px" height="18px" borderRadius="4px" />
    </div>
  </div>
);
